import { createBrowserRouter } from "react-router-dom";
import {
  ACTIVITY_MONITORING,
  ACTIVITY_TREND,
  ADD_TEST_PERSON,
  ADMIN_CHOICE,
  EDIT_TEST_PERSON,
  FORGOT_PASSWORD,
  HOW_TO_TEST_TUG_FRONT,
  HOW_TO_TEST_TUG_SIDE,
  LOGIN,
  PERSON_DASHBOARD,
  SIGNUP,
  TEST_HISTORY,
  TUG_FRONT_INFO,
  TUG_SIDE_INFO,
  USER_LIST,
  VIEW_TEST_PERSON,
} from "./routerPath";
import Layout from "../Layout";
import App from "../App";
import HistoryTab from "../components/userDetail/history/HistoryTab";
import TugSide from "../components/userDetail/testModule/tug/tugSide/TugSide";
import TugFront from "../components/userDetail/testModule/tug/tugFront/TugFront";
import HowtoTestTugFront from "../components/userDetail/testModule/tug/howToTest/howToTestTugFront/HowtoTestTugFront";
import HowtoTestTugSide from "../components/userDetail/testModule/tug/howToTest/howToTestTugSide/HowtoTestTugSide";
import PersonDashboard from "../components/userDetail/personDashboard/PersonDashboard";
import ActivityMonitoring from "../components/userDetail/activityMonitoring/ActivityMonitoring";
import ActivityTrend from "../components/userDetail/activityMonitoring/ActivityTrend";
import MmtLogin from "../components/mmtAuth/MmtLogin";
import MmtSignupFlow from "../components/mmtAuth/MmtSignupFlow";
import MmtForgotPasswordFlow from "../components/mmtAuth/MmtForgotPasswordFlow";
import MmtUserList from "../components/mmtUserList/MmtUserList";
import MmtAddTestPerson from "../components/testPerson/MmtAddTestPerson";
import MmtEditTestPerson from "../components/testPerson/MmtEditTestPerson";
import RequireSession from "../components/mmtAuth/RequireSession";
import AdminChoice from "../components/mmtAuth/AdminChoice";

const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "/",
            element: <MmtLogin />,
          },
          {
            path: LOGIN,
            element: <MmtLogin />,
          },
          {
            path: SIGNUP,
            element: <MmtSignupFlow />,
          },
          {
            path: FORGOT_PASSWORD,
            element: <MmtForgotPasswordFlow />,
          },
          {
            path: ADMIN_CHOICE,
            element: (
              <RequireSession>
                <AdminChoice />
              </RequireSession>
            ),
          },
          {
            path: USER_LIST,
            element: (
              <RequireSession>
                <MmtUserList />
              </RequireSession>
            ),
          },
          {
            path: ADD_TEST_PERSON,
            element: (
              <RequireSession>
                <MmtAddTestPerson />
              </RequireSession>
            ),
          },
          {
            path: EDIT_TEST_PERSON,
            element: (
              <RequireSession>
                <MmtEditTestPerson />
              </RequireSession>
            ),
          },
          {
            path: VIEW_TEST_PERSON,
            element: (
              <RequireSession>
                <MmtEditTestPerson readOnly />
              </RequireSession>
            ),
          },
          {
            path: PERSON_DASHBOARD,
            element: <PersonDashboard />,
          },
          {
            path: ACTIVITY_MONITORING,
            element: <ActivityMonitoring />,
          },
          {
            path: ACTIVITY_TREND,
            element: <ActivityTrend />,
          },
          {
            path: TUG_SIDE_INFO,
            element: <TugSide />,
          },
          {
            path: TUG_FRONT_INFO,
            element: <TugFront />,
          },
          {
            path: HOW_TO_TEST_TUG_FRONT,
            element: <HowtoTestTugFront />,
          },
          {
            path: HOW_TO_TEST_TUG_SIDE,
            element: <HowtoTestTugSide />,
          },
          {
            path: TEST_HISTORY,
            element: <HistoryTab />,
          },
        ],
      },
    ],
  },
]);
export default router;
